export const FIVE_SECONDS = 5000
export const FIVE_MINUTES = 5 * 60 * 1000
export const WEEK_MILLISECONDS = 7 * 24 * 60 * 60 * 1000
export const DAY_MILLISECONDS = 24 * 60 * 60 * 1000
